import React from 'react';
import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const riskColor = {
  NORMAL: 'success',
  LOW_CONFIDENCE: 'warning',
  HIGH_DRAWDOWN: 'error',
  HIGH_VOLATILITY: 'warning',
  PARTIAL: 'warning',
  FAILED: 'error',
};

const EngineRunsTable = ({ rows = [] }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Engine Runs</Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Run ID</TableCell>
              <TableCell>Symbol</TableCell>
              <TableCell>TF</TableCell>
              <TableCell>Signal</TableCell>
              <TableCell align="right">Conf</TableCell>
              <TableCell>Risk</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Skipped</TableCell>
              <TableCell align="right">Duration</TableCell>
              <TableCell>At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.engine_run_id}>
                <TableCell sx={{ fontFamily: 'monospace' }}>{row.engine_run_id}</TableCell>
                <TableCell>{row.symbol}</TableCell>
                <TableCell>{row.timeframe}</TableCell>
                <TableCell>{row.signal || '-'}</TableCell>
                <TableCell align="right">{Number(row.confidence || 0)}%</TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={row.risk_status || '-'}
                    color={riskColor[row.risk_status] || 'default'}
                  />
                </TableCell>
                <TableCell>{row.execution_action || '-'}</TableCell>
                <TableCell>{row.skipped_reason || '-'}</TableCell>
                <TableCell align="right">{Number(row.duration_ms || 0)} ms</TableCell>
                <TableCell>{row.created_at ? new Date(row.created_at).toLocaleString() : '-'}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={10}>
                  <Box sx={{ py: 2, textAlign: 'center', color: 'text.secondary' }}>
                    No engine runs found
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default EngineRunsTable;
